import * as React from 'react';
import { styled } from '@glitz/react';
import { registerComponent, translate } from '@avensia/excite';
import { createMinLargeViewportDecorator } from 'webapp/viewport';
import { Main, Block, edgeMarginsDecorator, maxContentNormalWidthDecorator } from 'webapp/components/page-layout';
import { ContentList } from '@avensia/excite-ninetailed';

export const NotFoundPage = registerComponent<NordicNest.Api.ContentNotFoundApiModel>(props => {
  return (
    <Base>
      <Content>
        <StatusHeader>
          <StatusCode>404</StatusCode>
          <StatusMessage>{translate(t => t.error404StatusMessage)}</StatusMessage>
        </StatusHeader>
        <ErrorMessage>{translate(t => t.error404Message)}</ErrorMessage>
      </Content>
      <ContentList {...props.content} />
    </Base>
  );
});

const StatusCode = styled.span(createMinLargeViewportDecorator({ fontSize: 200, fontWeight: 700 }), {
  display: 'block',
  fontSize: 100,
});

const StatusMessage = styled.span(createMinLargeViewportDecorator({ fontSize: t => t.fontSize.xl, fontWeight: 100 }), {
  display: 'block',
});

const StatusHeader = styled.h1({ textAlign: 'center' });

const ErrorMessage = styled.p({ fontSize: t => t.fontSize.xs, textAlign: 'center' });

const Base = styled(
  Main,
  createMinLargeViewportDecorator({
    margin: { xy: 'auto' },
    padding: { y: t => t.spacing.xl },
  }),
  {
    padding: { y: t => t.spacing.l },
  },
);

const Content = styled(Block, maxContentNormalWidthDecorator, edgeMarginsDecorator);
